export default __webpack_public_path__ + "static/media/DIP.e97d0485.png";